import { Component, ElementRef, HostListener, OnInit, ViewEncapsulation } from '@angular/core';


@Component({
  selector: 'app-image-lightbox',
  templateUrl: './image-lightbox.component.html',
  styleUrls: ['./image-lightbox.component.scss'],
  standalone: true
})
export class ImageLightboxComponent implements OnInit {

  constructor() {

   
  }

  ngOnInit(): void {
   
  }

  closeimgLightBox() {
    document.getElementById('imgLightBox').style.display = "none";
  }
}
